import type { ApolloCache } from "@apollo/client";

import {
  createTeam as createTeamMutation,
  updateGroupName as updateGroupNameMutation,
} from "src/queries/mutations/group.graphql";
import { updateTeamAttributes as updateTeamAttributesMutation } from "src/queries/mutations/updateTeamAttributes.graphql";
import eventEmitter, { EVENTS } from "src/services/eventEmitter";

import type { BoundOverlayMutate } from "./overlayMutate";

type RenameResult = { result?: unknown };
type AttributesResult = { group?: unknown };
type CreateResult = { team?: unknown };

export type CreateTeamIdentityVariables = {
  parentId: string;
  name: string;
  type: string;
};

// ponytail: dailyRate stays off this interface until the BE *WithOption twin exists

export const renameTeamIdentity = async (
  write: BoundOverlayMutate,
  groupId: string,
  name: string
) => {
  const response = await write<{ groupId: string; name: string }, RenameResult>(
    {
      mutation: updateGroupNameMutation,
      variables: { groupId, name },
    }
  );
  eventEmitter.emit(EVENTS.GROUP_RENAMED, response.data?.result);
  return response;
};

export const setTeamIdentityAttributes = async (
  write: BoundOverlayMutate,
  groupId: string,
  attributes: unknown
) => {
  const response = await write<
    { groupId: string; attributes: unknown },
    AttributesResult
  >({
    mutation: updateTeamAttributesMutation,
    variables: { groupId, attributes },
  });
  eventEmitter.emit(EVENTS.GROUP_ATTRS_UPDATED, response.data?.group);
  return response;
};

export const createTeamIdentity = async (
  write: BoundOverlayMutate,
  variables: CreateTeamIdentityVariables,
  update?: (cache: ApolloCache, result: { data?: CreateResult | null }) => void
) =>
  write<CreateTeamIdentityVariables, CreateResult>({
    mutation: createTeamMutation,
    variables,
    update: (cache, result) => {
      update?.(cache, result);
      eventEmitter.emit(
        EVENTS.NEW_GROUP_ADDED,
        result.data?.team,
        cache,
        variables
      );
    },
  });
